module.exports = __webpack_public_path__ + "static/media/CV_Devleena_Das_2024.6ec2a2e9.pdf";